var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        var authFooter = React.createElement("footer", null);
        var guestFooter = (React.createElement("footer", { className: "center-align" },
            React.createElement("span", { className: "copyright white-text" },
                "Copyright \u00A9 ",
                new Date().getFullYear(),
                " CIFH Gruppe UG (haftungsbeschr\u00E4nkt) |",
                " ",
                React.createElement("a", { href: "https://modinet.io/imprint", className: "white-link" }, "Impressum"))));
        return React.createElement("div", null, this.props.hasUser ? authFooter : guestFooter);
    };
    return Footer;
}(Component));
export default Footer;



//////////////////
// WEBPACK FOOTER
// ./src/components/layout/Footer.tsx
// module id = 1008
// module chunks = 0